import { useNavigate } from 'react-router-dom';
import './SignOut.page.css';

// TODO Furqan, Move this to a component, also make it a function not a const. add an explicit JSX.Element to its return type

const Signout = () => {
  const navigate = useNavigate();

  const handleSignout = () => {
    localStorage.removeItem('token'); // Remove token from localStorage
    navigate('/');
    window.location.reload(); // Reload the page after navigation
  };

  return (
    <button onClick={handleSignout} className="SignOutButton">
      Sign Out
    </button>
  );
};

export default Signout;
